// @ts-nocheck
// todo: clean up, not used
import { useState, useEffect, useRef, useCallback, FC } from 'react';
import { Editor, Monaco } from '@monaco-editor/react';
import debounce from 'lodash/debounce';
import { logger } from '../../utils';

type JSONEditorProps = {
  path: string;
  initialValue: string | undefined;
  onChange: (value: string) => void;
};

export const JSONEditor: FC<JSONEditorProps> = ({ path, initialValue, onChange }) => {
  const editorRef = useRef<Monaco | null>(null);
  const [value, setValue] = useState<string | undefined>(initialValue);

  const validateAndFormatJSON = debounce(() => {
    try {
      JSON.parse(value as string);
      onChange(value as string);
      editorRef?.current?.getAction('editor.action.formatDocument').run();
    } catch (e) {
      logger.log('Invalid JSON:', e);
    }
  }, 1000);

  useEffect(() => {
    validateAndFormatJSON();

    // Cleanup the debounce on component unmount
    return () => {
      validateAndFormatJSON.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value]);

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const editorOptions = {
    minimap: { enabled: false },
    lineNumbers: 'off',
    contextmenu: false,
    automaticLayout: true,
    scrollBeyondLastLine: false,
    extraEditorClassName: 'editor-pane',
  };

  const handleEditorDidMount = useCallback((editor: Monaco) => {
    editorRef.current = editor;
    editor.getAction('editor.action.formatDocument').run();
  }, []);

  if (!path) {
    return <>Loading ...</>;
  }

  return (
    <Editor
      defaultLanguage="json"
      value={value}
      onMount={handleEditorDidMount}
      theme="dark"
      path={path}
      onChange={(v: string | undefined) => setValue(v)}
      options={editorOptions}
    />
  );
};
